module.exports = __webpack_public_path__ + "static/media/nataliaw.3e91469b.jpg";